import React from 'react'

import InputField from '@components/forms/input_field'
import ThemedButton from '@components/themed_button'

export function EmailField(props) {
  return (
    <InputField
      value={props.email}
      label={props.t('d_email_address')}
      id='email'
      inputName='email'
      type='email'
      autoComplete='username'
      error={props.emailError}
      valueHandler={props.valueHandler}
      blurHandler={props.emailBlurHandler}
      focusHandler={props.emailFocusHandler}
    />
  )
}

export function SubmitButton(props) {
  return (
    <ThemedButton
      onClick={props.handleFormSubmit}
      loading={props.loading}
      disabled={!props.valid}
    >
      {props.t('a_send_reset_link')}
    </ThemedButton>
  )
}
